export default __webpack_public_path__ + "static/media/palaceofcetriss.65889d97.jpg";